/* unplugin-vue-components disabled */import "core-js/modules/es.array.filter.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalMapView from '@/components/GaoDeMap/ModalMapView';
import utils from '@/utils/utils';
export default {
  name: 'HomeCard',
  props: {
    codeMap: Object
  },
  components: {
    ModalMapView: ModalMapView
  },
  watch: {
    'codeMap.40013': {
      handler: function handler() {
        this.initAddress();
      },
      immediate: true
    }
  },
  computed: {
    showCard: function showCard() {
      var _this = this;
      return ['90002', '90003', '90004', '90005', '90006', '90007'].filter(function (v) {
        return +_this.codeMap[v];
      }).length > 0;
    },
    showMap: function showMap() {
      return this.center[0] && this.center[1];
    }
  },
  data: function data() {
    return {
      center: [],
      showtMapAddress: false
    };
  },
  created: function created() {},
  methods: {
    initAddress: function initAddress() {
      var _this2 = this;
      utils.getLngLat(this.codeMap['40013']).then(function (res) {
        _this2.center = res;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
};